/* PDP: atomická vazba variant ID / SKU / cena / sklad / media; CTA disabled do validní varianty. */
(function () {
  'use strict';
  const root = document.querySelector('[data-product]');
  const dataEl = document.querySelector('[data-product-json]');
  if (!root || !dataEl) return;
  const T = window.ladaTheme || { strings: {} };
  const S = T.strings;
  const data = JSON.parse(dataEl.textContent);
  const form = document.querySelector('[data-product-form]');
  const idInput = form.querySelector('[data-variant-id]');
  const addBtn = form.querySelector('[data-add-button]');
  const addLabel = form.querySelector('[data-add-label]');
  const errBox = form.querySelector('[data-product-error]');
  const statusTitle = form.querySelector('[data-variant-status-title]');
  const statusText = form.querySelector('[data-variant-status-text]');
  const skuEl = document.querySelector('[data-variant-sku]');
  const photoNote = form.querySelector('[data-photo-note]');
  const colorIndex = data.options.findIndex(o => /barva|color|colour|kolor/i.test(o));
  const availText = document.querySelector('[data-availability-text]');
  const dispatchText = document.querySelector('[data-dispatch-text]');
  const priceWrap = document.querySelector('[data-price-wrap]');
  const sticky = document.querySelector('[data-sticky-buy]');
  const stickyAdd = document.querySelector('[data-sticky-add]');
  /* Částky: Liquid dodává hotový text (priceText / compareText, money_with_currency = měna trhu); JS nic nepřepočítává. */
  const fmt = window.ladaFormatMoney || (c => (c / 100).toFixed(0));
  const money = (v, key) => (v && v[key + 'Text']) ? v[key + 'Text'] : fmt(v ? v[key] : 0);
  const plural = window.ladaPlural || ((n, forms) => (forms && (forms.other || forms.many) || '').replace(/__N__/g, String(n)));
  const single = root.dataset.single === 'true';
  const mobile = window.matchMedia('(max-width: 900px)');
  let adding = false;

  /* MOB-07: jediná spodní lišta – jen na mobilu, jen když hlavní CTA není vidět, ne přes patičku; před volbou vede k výběru */
  const stickyState = { state: 'none', v: null, ctaVisible: true, ctaAbove: false, footerVisible: false, keyboard: false };
  function stickyLabel(state) {
    if (state === 'stock' || state === 'order') return S.addToCart;
    if (state === 'soldout') return S.soldOut;
    if (state === 'request') return S.askAvailability || S.onRequest;
    return data.chooseLabel || S.chooseSize;
  }
  function refreshSticky() {
    if (!sticky) return;
    /* PDP-03: lišta až poté, co hlavní CTA odejde nad horní hranu viewportu – ne hned po příchodu přes fotografii;
       skrytá při patičce, mobilní klávesnici a (přes CSS) otevřeném dialogu */
    const show = mobile.matches && !stickyState.ctaVisible && stickyState.ctaAbove && !stickyState.footerVisible && !stickyState.keyboard;
    sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('has-sticky-buy', show);
    if (stickyAdd) { stickyAdd.textContent = stickyLabel(stickyState.state); stickyAdd.disabled = stickyState.state === 'soldout' || adding; }
    const pv = sticky.querySelector('[data-sticky-price]'); const vv = sticky.querySelector('[data-sticky-variant]');
    if (stickyState.v) { pv.textContent = money(stickyState.v, 'price'); vv.textContent = stickyState.v.title; }
    else { pv.textContent = priceWrap ? priceWrap.textContent.trim() : ''; vv.textContent = stickyState.state === 'unavailable' ? S.unavailable : ''; }
  }
  if (stickyAdd) stickyAdd.addEventListener('click', () => {
    const st = stickyState.state;
    if (st === 'stock' || st === 'order') { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); return; }
    let target = null;
    if (st === 'request') target = document.querySelector('[data-availability-block]');
    else { const i = selections().findIndex(x => x === null); target = form.querySelector('[data-option-index="' + (i < 0 ? 0 : i) + '"]') || form; }
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const first = target.querySelector('input:not(:disabled), a'); if (first) first.focus({ preventScroll: true });
  });
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => { es.forEach(e => { stickyState.ctaVisible = e.isIntersecting; stickyState.ctaAbove = !e.isIntersecting && e.boundingClientRect.top < 0; }); refreshSticky(); }).observe(addBtn);
    if (window.visualViewport) {
      const vv = window.visualViewport;
      vv.addEventListener('resize', () => { stickyState.keyboard = vv.height < window.innerHeight * 0.75; refreshSticky(); });
    }
    const footer = document.querySelector('.footer');
    if (footer) new IntersectionObserver(es => { es.forEach(e => { stickyState.footerVisible = e.isIntersecting; }); refreshSticky(); }).observe(footer);
  }

  function selections() {
    return data.options.map((_, i) => {
      const checked = form.querySelector('[data-option-index="' + i + '"] input:checked');
      return checked ? checked.value : null;
    });
  }
  function findVariant(sel) {
    if (sel.some(v => v === null)) return null;
    return data.variants.find(v => v.options.every((o, i) => o === sel[i])) || false; /* false = kombinace neexistuje */
  }
  function variantState(v) {
    if (!v) return 'unavailable';
    if (!v.available) return 'soldout';
    const tracked = v.management === 'shopify';
    if (data.mode === 'on_request') return 'request';
    if (data.mode === 'made_to_order') return 'order';
    if (tracked && v.qty <= 0 && v.policy === 'continue') return 'order';
    if (!tracked) return 'stock';
    return 'stock';
  }
  function stockText(v, state) {
    if (state === 'soldout') return S.variantSoldOut || S.soldOut;
    if (state === 'unavailable') return S.unavailable;
    if (state === 'request') return S.onRequest || '';
    if (state === 'order') return data.lead ? data.madeLabel + ' · ' + data.lead : data.madeLabel;
    if (v.management === 'shopify' && v.qty > 0 && S.inStockCount) return plural(v.qty, S.inStockCount);
    return S.inStock || '';
  }

  /* dostupnost jednotlivých hodnot vzhledem k ostatním zvoleným opcím */
  function refreshOptionStates(sel) {
    data.options.forEach((_, i) => {
      const fs = form.querySelector('[data-option-index="' + i + '"]');
      if (!fs) return;
      fs.querySelectorAll('input[data-option-value]').forEach(input => {
        const label = fs.querySelector('label[for="' + input.id + '"]');
        const candidates = data.variants.filter(v => v.options[i] === input.value && v.options.every((o, j) => j === i || sel[j] === null || o === sel[j]));
        const exists = candidates.length > 0;
        const anyAvail = candidates.some(v => v.available);
        input.disabled = !exists;
        label.classList.toggle('is-unavailable', !exists);
        label.classList.toggle('is-soldout', exists && !anyAvail);
        label.classList.toggle('is-active', input.checked);
        label.setAttribute('aria-disabled', String(!exists));
        if (!exists) label.title = S.unavailable; else if (!anyAvail) label.title = S.soldOut; else label.removeAttribute('title');
      });
      const meta = fs.querySelector('[data-option-meta]');
      if (meta) meta.textContent = sel[i] || S.select || '';
    });
  }

  /* MOB-06: galerie – na mobilu swipe (scroll-snap, všechny snímky vedle sebe), na desktopu přepínání; náhledy fungují všude */
  const gallery = document.querySelector('[data-gallery-main]');
  const slides = gallery ? Array.from(gallery.querySelectorAll('[data-media-id]')) : [];
  const counter = document.querySelector('[data-gallery-count]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const firstShown = slides.find(s => !s.hidden);
  let currentMedia = firstShown ? String(firstShown.dataset.mediaId) : null;
  function slideFor(id) { return slides.find(x => String(x.dataset.mediaId) === String(id)); }
  function markActive(id) {
    document.querySelectorAll('[data-thumb]').forEach(t => { const on = String(t.dataset.mediaId) === String(id); t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    if (counter && slides.length > 1) {
      const i = slides.indexOf(slideFor(id));
      if (i >= 0) counter.textContent = counter.dataset.label.replace('__i__', i + 1).replace('__n__', slides.length);
      counter.hidden = !mobile.matches;
    }
    const inline = document.querySelector('[data-gallery-count-inline]');
    if (inline && slides.length > 1) { const i = slides.indexOf(slideFor(id)); if (i >= 0) inline.textContent = (i + 1) + ' / ' + slides.length; }
  }
  function stepMedia(d) {
    if (slides.length < 2) return;
    const i = slides.indexOf(slideFor(currentMedia));
    const n = (i + d + slides.length) % slides.length;
    showMedia(slides[n].dataset.mediaId);
  }
  function applyGalleryMode() {
    if (!slides.length) return;
    if (mobile.matches) { slides.forEach(s => { s.hidden = false; }); const s = slideFor(currentMedia); if (s) gallery.scrollTo({ left: s.offsetLeft, behavior: 'auto' }); }
    else slides.forEach(s => { s.hidden = String(s.dataset.mediaId) !== String(currentMedia); });
    markActive(currentMedia);
  }
  function showMedia(id, instant) {
    if (!id) return;
    const s = slideFor(id); if (!s) return;
    currentMedia = String(id);
    if (mobile.matches) gallery.scrollTo({ left: s.offsetLeft, behavior: reduced || instant ? 'auto' : 'smooth' });
    else slides.forEach(x => { x.hidden = x !== s; });
    markActive(currentMedia);
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]'); if (t) { showMedia(t.dataset.mediaId); return; }
    if (e.target.closest('[data-gallery-prev]')) stepMedia(-1);
    else if (e.target.closest('[data-gallery-next]')) stepMedia(1);
  });
  /* B37: video „jak správně nosit“ v okně – spustí se po otevření, po zavření se zastaví a vrátí na začátek */
  (function () {
    const modal = document.querySelector('[data-video-modal]');
    const vid = modal ? modal.querySelector('video') : null;
    if (!vid) return;
    modal.addEventListener('lada:dialog-open', () => { const p = vid.play(); if (p && p.catch) p.catch(() => {}); });
    modal.addEventListener('lada:dialog-close', () => { vid.pause(); try { vid.currentTime = 0; } catch (err) { /* noop */ } });
  })();
  /* PDP-02: odkaz zpět do kolekce – pokud zákaznice přišla z kolekce téhož webu, vrátit ji i se stavem (filtry, strana) */
  (function () {
    const back = document.querySelector('[data-back-link]');
    if (!back || !document.referrer) return;
    try {
      const ref = new URL(document.referrer);
      if (ref.origin === window.location.origin && /\/collections\//.test(ref.pathname) && !/\/products\//.test(ref.pathname)) back.href = ref.href;
    } catch (err) { /* noop */ }
  })();
  /* MD-02: prohlížeč fotografií (product-zoom.js) čte aktuální snímek a po zavření galerii přepne na naposledy prohlížený */
  window.ladaGallery = { current: () => currentMedia, show: (id, instant) => showMedia(id, instant) };
  if (gallery && slides.length > 1) {
    /* tečky/čítač se přepínají průběžně během swipu (každý snímek), ne až po doběhnutí posunu */
    let scrollRaf = 0;
    gallery.addEventListener('scroll', () => {
      if (!mobile.matches || scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = 0;
        const i = Math.min(slides.length - 1, Math.max(0, Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth))));
        const s = slides[i];
        if (s && String(s.dataset.mediaId) !== String(currentMedia)) { currentMedia = String(s.dataset.mediaId); markActive(currentMedia); }
      });
    }, { passive: true });
    mobile.addEventListener('change', applyGalleryMode);
    applyGalleryMode();
  }

  function update(pushUrl) {
    const sel = selections();
    const v = single ? data.variants[0] : findVariant(sel);
    if (!single) refreshOptionStates(sel);
    const state = v ? variantState(v) : (v === false ? 'unavailable' : 'none');

    if (v) {
      idInput.value = v.id; idInput.disabled = false;
      if (priceWrap) {
        const pv = priceWrap.querySelector('[data-price-value]'); if (pv) pv.textContent = money(v, 'price');
        let cmp = priceWrap.querySelector('[data-compare-price]');
        if (v.compare > v.price) { if (!cmp) { cmp = document.createElement('s'); cmp.setAttribute('data-compare-price', ''); pv.after(cmp); } cmp.textContent = money(v, 'compare'); } else if (cmp) cmp.remove();
      }
      const txt = stockText(v, state);
      /* FIN-02: dostupnost a termín jsou na stránce jen jednou – v bloku dostupnosti (availText) nebo v bloku výroby na
         objednávku. Řádek varianty nese jen identifikaci (název, SKU); stav doplní pouze tam, kde jinde chybí:
         vyprodaná/neexistující kombinace u modelu na objednávku (blok dostupnosti tam není). */
      const stateElsewhere = !!availText || (state !== 'soldout' && state !== 'unavailable');
      if (statusTitle) statusTitle.textContent = (S.variantSelected || '__V__').replace('__V__', v.title) + (stateElsewhere ? '' : ' · ' + txt);
      if (statusText) statusText.textContent = (data.showSku && v.sku) ? (S.sku || 'SKU') + ' ' + v.sku : '';
      if (skuEl) skuEl.textContent = (data.showSku && v.sku) ? (skuEl.dataset.label || S.sku || 'SKU') + ' ' + v.sku : '';
      if (availText) { availText.textContent = txt; availText.className = 'availability ' + (state === 'soldout' ? 'sold' : state === 'order' ? 'order' : state === 'request' ? 'neutral' : state === 'unavailable' ? 'unavailable' : 'stock'); }
      if (dispatchText) dispatchText.textContent = state === 'order' || state === 'request' ? '' : (data.dispatch || '');
      showMedia(v.media, !pushUrl);
      const ok = state === 'stock' || state === 'order';
      addBtn.disabled = !ok || adding;
      addLabel.textContent = state === 'request' ? (S.onRequest || '') : ok ? S.addToCart : S.soldOut;
      stickyState.state = state; stickyState.v = v; refreshSticky();
      if (pushUrl && !single) { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    } else {
      idInput.value = ''; idInput.disabled = true;
      addBtn.disabled = true;
      addLabel.textContent = state === 'unavailable' ? S.unavailable : (data.chooseLabel || S.chooseSize);
      if (statusTitle) statusTitle.textContent = state === 'unavailable' ? S.unavailable : (data.selectLabel || '');
      if (statusText) statusText.textContent = '';
      if (skuEl) skuEl.textContent = (data.showSku && skuEl.dataset.skuBase) ? (skuEl.dataset.label || S.sku || 'SKU') + ' ' + skuEl.dataset.skuBase : '';
      stickyState.state = state; stickyState.v = null; refreshSticky();
    }
    refreshPhotoNote(sel, v);
  }
  /* MD-04: fotografie vs. vybraná barva. Varianta s vlastní fotografií → galerie se přepne, poznámka se skryje.
     Jinak podle metapole lada.photo_color (odstín na hlavní fotografii): shoda → nic; rozdíl → „Na fotografii je X.
     Vybraná barva: Y.“ Bez metapole od druhého odstínu opatrná věta („může ukazovat jiné provedení“). */
  function refreshPhotoNote(sel, v) {
    if (!photoNote || colorIndex < 0) return;
    const selected = sel[colorIndex];
    const colorOpt = form.querySelector('[data-option-index="' + colorIndex + '"]');
    const firstColor = colorOpt ? (colorOpt.querySelector('input[data-option-value]') || {}).value : null;
    const hasOwnMedia = !!(v && v.media);
    const photoColor = (photoNote.dataset.photoColor || '').trim();
    let text = '';
    if (selected && !hasOwnMedia) {
      if (photoColor) { if (photoColor.toLowerCase() !== selected.toLowerCase()) text = (photoNote.dataset.template || '').replace('__P__', photoColor).replace('__S__', selected); }
      else if (firstColor && selected !== firstColor) text = (photoNote.dataset.templateGeneric || '').replace('__S__', selected);
    }
    photoNote.textContent = text;
    photoNote.hidden = !text;
  }
  function clearError() { errBox.classList.remove('is-visible'); errBox.textContent = ''; }
  form.addEventListener('change', e => { if (e.target.matches('[data-option-value]')) { clearError(); update(true); } });
  mobile.addEventListener('change', () => update(false));

  /* add to cart */
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (adding) return;
    if (addBtn.disabled || idInput.disabled) { errBox.textContent = data.chooseLabel || S.chooseSize; errBox.classList.add('is-visible'); return; }
    clearError();
    adding = true;
    addBtn.disabled = true; refreshSticky();
    addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true');
    const id = parseInt(idInput.value, 10);
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(r => r.json().then(j => ({ ok: r.ok, body: j })))
      .then(({ ok, body }) => {
        if (!ok) throw new Error(body.description || body.message || S.addError);
        return fetch(T.routes.cart + '.js').then(r => r.json()).then(cart => {
          if (window.ladaUpdateCartCount) window.ladaUpdateCartCount(cart.item_count);
          if (window.ladaToast) window.ladaToast(S.added.replace('{{ title }}', data.title));
          const v = data.variants.find(x => x.id === id);
          if (window.ladaTrack) window.ladaTrack('add_to_cart', { currency: T.currency, value: v ? v.price / 100 : 0, items: [{ item_id: v ? v.sku || String(v.id) : String(id), item_name: data.title, item_variant: v ? v.title : '', price: v ? v.price / 100 : 0, quantity: 1 }] });
        });
      })
      .catch(err => { const msg = (err && err.message) || S.addError; errBox.textContent = msg; errBox.classList.add('is-visible'); if (window.ladaToast) window.ladaToast(msg, 'error'); })
      .finally(() => { adding = false; addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); update(false); /* AR-08: chyba zůstává viditelná až do změny volby nebo nového pokusu */ });
  });

  /* view_item */
  if (window.ladaTrack) {
    const v0 = data.variants[0];
    window.ladaTrack('view_item', { currency: T.currency, value: v0 ? v0.price / 100 : 0, items: [{ item_id: String(data.id), item_name: data.title, price: v0 ? v0.price / 100 : 0 }] });
  }
  update(false);
})();
